import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  clearTabContent
} from 'zoomforth_codesbane_editor/action_creators/sections.js';

import {
  getLongDisplayName
} from 'zoomforth_codesbane_viewer/lib/sections.js';

const mapStateToProps = (state, { tab }) => {

  const displayName = tab?.content?.section ? getLongDisplayName(tab.content.section) + ' ' : '';
  return {
    title: 'Really remove content?',
    body: `You are about to remove the ${displayName}Section from this tab. 
      This will delete all of the content in this section. This cannot be undone.`,
    confirmText: 'Remove Content',
    cancelText: 'Cancel'
  };
};

const mapDispatchToProps = (dispatch, { parentSectionId, tabId }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      dispatch(clearTabContent(parentSectionId, tabId));
      dispatch(closeModal());
    }
  }
);

const ConfirmClearTabContentModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmClearTabContentModal.editorModalName = 'ConfirmClearTabContentModal';

export default ConfirmClearTabContentModal;
